import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import {ToasterConfig} from 'angular2-toaster';
import { createChart } from 'lightweight-charts';
import {BackendApiService} from './services/backend-api.service';

import _ from "lodash";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'light-view';
  public config1: ToasterConfig = new ToasterConfig({
    positionClass: 'toast-bottom-right',
    limit: 2
  });
  
  constructor(  private backendApiService: BackendApiService) {}
  ngOnInit() {
    
  }
}
